
import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles(() => ({
  gridList: {
    flexWrap: 'nowrap',
    overflow: 'auto',
  },
  horizontalList: {
    display: 'inline-flex',
    flex: 'none',
  },
  containerImage: {
    position: 'relative',
    paddingTop: '20px',
    '& > img': {
      width: '480px',
    },
  },
  cardBodyList: {
    minWidth: '300px',
    margin: 'auto',
    maxWidth: '380px',
    padding: '20px',
  },
  center: {
    flexGrow: 1,
    margin: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
}));
